import { render, staticRenderFns } from "./TributeEntry.vue?vue&type=template&id=153fb0ac&scoped=true"
import script from "./TributeEntry.vue?vue&type=script&lang=js"
export * from "./TributeEntry.vue?vue&type=script&lang=js"
import style0 from "./TributeEntry.vue?vue&type=style&index=0&id=153fb0ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153fb0ac",
  null
  
)

export default component.exports